import React from 'react';
import FormHistory from 'modules/FormHistory';

const Presale = ({ contact, portfolioUuid, profileUuid }) => {
  const isCompany = contact.type === 'COMPANY';
  const key = isCompany
    ? 'c_presale'
    : 'p_presale';

  return <FormHistory
    formKey={key}
    contactName={contact.name}
    portfolioUuid={portfolioUuid}
    profileUuid={profileUuid}
  />;
};

export default Presale;
